module.exports = __webpack_public_path__ + "img/leftList2.a7a0edf7.svg";